// Changed-line counts per file, and the "unusually large" flag shown in the file list
// and the commit panel (approved before M3).
import { diffLines } from 'diff';

export type LineStats = { added: number; removed: number; total: number; large: boolean };

/** Flag a change as unusually large above this many changed lines… */
export const LARGE_MIN_LINES = 40;
/** …when that is also more than this share of the file. */
export const LARGE_SHARE = 0.3;

export function lineStats(base: string, current: string): LineStats {
  let added = 0, removed = 0;
  for (const part of diffLines(base, current)) {
    if (part.added) added += part.count ?? 0;
    else if (part.removed) removed += part.count ?? 0;
  }
  const total = Math.max(base.split('\n').length, current.split('\n').length);
  const changed = added + removed;
  return { added, removed, total, large: changed > LARGE_MIN_LINES && changed > LARGE_SHARE * total };
}
